import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import ko from 'vee-validate/dist/locale/ko'

// vee-validate 한글설정
Validator.localize('ko', ko)

// vee-validate Defalut Set
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  fieldsBagName: 'formFields',
  dictionary: {
    ko: {
      attributes: {
        id: '아이디',
        password: '비밀번호',
        password2: '비밀번호 확인',
        new_password: '변경 비밀번호',
        new_password2: '변경 비밀번호 확인',
        name: '담당자',
        contact: '연락처',
        mobile_no: '핸드폰번호',
        email: '이메일',
        crn: '사업자 등록번호',
        license_file: '사업자등록증',
        company: '회사명',
        address: '주소',
        company_contact: '회사연락처',
        tax_email: '세금계산서 발행 이메일',
        inquiryType: '문의유형',
        inquiryMemo: '문의내용',
        totalCapacity: '총용량',
        hopeMonth: '희망납품월',
        business_year: '사업년도',
        customer_name: '고객명',
        contract_no: '계약번호',
        contract_date: '계약일',
        install_address: '설치주소',
        install_capacity: '설치용량',
        copy_contract: '계약서사본',
        power_generation_step: '발전사업 허가 진행단계',
        development_permit_step: '개발행위 허가 진행단계',
        installType: '설치구분',
        owner_name: '사업자명',
        onm_name: '성명',
        plant_name: '발전소명',
        install_position: '설치위치',
        install_type: '설치유형',
        driving_method: '구동방식',
        deduction_date: '공제보험 개시일자',
        permission_file: '발전사업허가증',
        coupon_name: '쿠폰이름',
        promotion_code: '쿠폰코드',
        discount_desc: '할인내용'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/validate.js